// Sonneries générées par Web Audio (aucun fichier audio) : sonnerie d'appel entrant et tonalité de retour d'appel.
// Le navigateur peut refuser le son tant que l'utilisateur n'a pas interagi avec la page : on ignore alors l'erreur.
export type CallToneKind = 'ringtone' | 'ringback';

interface ToneBurst {
  frequency: number;
  start: number;
  duration: number;
}

const PATTERNS: { [kind in CallToneKind]: { period: number; bursts: ToneBurst[] } } = {
  // Deux bips courts toutes les 2 s
  ringtone: { period: 2000, bursts: [{ frequency: 880, start: 0, duration: 0.35 }, { frequency: 880, start: 0.5, duration: 0.35 }] },
  // Tonalité européenne : 425 Hz, 1,5 s toutes les 5 s
  ringback: { period: 5000, bursts: [{ frequency: 425, start: 0, duration: 1.5 }] },
};

export class CallTones {

  private context: AudioContext | null = null;
  private timer: ReturnType<typeof setInterval> | null = null;

  play(kind: CallToneKind): void {
    this.stop();
    try {
      const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
      if (!AudioContextClass) {
        return;
      }
      this.context = new AudioContextClass();
      const pattern = PATTERNS[kind];
      const ring = () => this.burst(pattern.bursts);
      ring();
      this.timer = setInterval(ring, pattern.period);
      if (kind === 'ringtone') {
        navigator.vibrate?.([350, 150, 350]);
      }
    } catch {
      this.stop();
    }
  }

  stop(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.context) {
      this.context.close().catch(() => { });
      this.context = null;
    }
  }

  private burst(bursts: ToneBurst[]): void {
    const context = this.context;
    if (!context) {
      return;
    }
    context.resume().catch(() => { });
    const now = context.currentTime;
    for (const tone of bursts) {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.frequency.value = tone.frequency;
      gain.gain.setValueAtTime(0, now + tone.start);
      gain.gain.linearRampToValueAtTime(0.15, now + tone.start + 0.02);
      gain.gain.setValueAtTime(0.15, now + tone.start + tone.duration - 0.02);
      gain.gain.linearRampToValueAtTime(0, now + tone.start + tone.duration);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start(now + tone.start);
      oscillator.stop(now + tone.start + tone.duration);
    }
  }
}
